:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._pos-relative{position:relative;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._fd-column{flex-direction:column;}
:root ._gap-t-space-lar3294{gap:var(--t-space-large);}
:root ._shrink-1{flex-shrink:1;}
:root ._fd-row{flex-direction:row;}
:root ._justify-space-betwe3241{justify-content:space-between;}
:root ._grow-1{flex-grow:1;}
:root ._items-center{align-items:center;}
:root ._mb-t-space-med104641{margin-bottom:var(--t-space-medium);}
:root ._cur-pointer{cursor:pointer;}
:root ._gap-t-space-med104641{gap:var(--t-space-medium);}